import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  PRRNCDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayPRRNCSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.PRRNC?.submetrics) {
    return <></>;
  }
  if (PRRNCDataCheck(metrics.PRRNC?.submetrics!)) {
    return <NoSubMetric />;
  }

  const { understandabilityNoConcession } = metrics.PRRNC?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {understandabilityNoConcession && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_understandability_noConcession'
                  defaultMessage='Understandability - No Concession'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_understandability_noConcession_def'
                defaultMessage='Percentage of 4 to 5-star responses to the “Easy to Understand” CCX rating of contacts where a concession was NOT issued.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric
            value={understandabilityNoConcession.datapoint}
            isBold
            isPercentage
          />
          <DisplaySubMetric
            value={understandabilityNoConcession.networkAverage}
            isPercentage
            datapointNull={understandabilityNoConcession.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayPRRNCSubMetrics;
